module.exports = __webpack_public_path__ + "img/symphony_576_darkblue.5f3e57ea.jpg";